import {
  useGetAllWaitingLinesObnlDataQuery,
  useGetWaitingLineObnlDataQuery,
  WaitingLineObnlDataFragment,
} from 'lib/graphql/graphql';
import { mergePaginatedList, usePagination } from 'lib/graphql/pagination';
import useEvent from 'providers/event/useEvent';
import { useMemo } from 'react';

import useAggregateFilter from '../../helpers/useAggregateFilter';

interface QueryInfos {
  loading: boolean
  hasNextPage: boolean
  fetchMore: () => Promise<any>
}

function useObnlDataQuery(selectedTime: string, selectedWaitingLine: string) {
  const { id: eventId } = useEvent();

  const filter = useAggregateFilter(selectedTime);

  const allQuery = usePagination(
    useGetAllWaitingLinesObnlDataQuery({
      variables: { eventId, filter },
      skip: selectedWaitingLine !== 'all',
    }),
    (d) => d.getAllWaitingLinesObnlData.lastEvaluated,
    (existing, incoming) => ({
      getAllWaitingLinesObnlData: mergePaginatedList(
        existing.getAllWaitingLinesObnlData,
        incoming.getAllWaitingLinesObnlData,
        'items',
      ),
    }),
  );

  const query = useGetWaitingLineObnlDataQuery({
    variables: { waitingLineId: selectedWaitingLine, filter },
    skip: selectedWaitingLine === 'all',
  });

  return useMemo<[WaitingLineObnlDataFragment[], QueryInfos]>(() => {
    if (selectedWaitingLine !== 'all') {
      const item = query.data?.getWaitingLineObnlData;
      return [item ? [item] : [], { ...query, hasNextPage: false, fetchMore: async () => {} }];
    }
    return [allQuery.data?.getAllWaitingLinesObnlData.items || [], allQuery];
  }, [allQuery, query, selectedWaitingLine]);
}

export default useObnlDataQuery;
